<div class="courses-categories-area pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span class="sub-title" i18n>Our Book</span>
            <h2 i18n>Browse Our Ghor Related Books</h2>
            <a routerLink="/books" class="default-btn"><i
                    class='bx bx-show-alt icon-arrow before'></i><span class="label" i18n>View All</span><i
                    class="bx bx-show-alt icon-arrow after"></i></a>
        </div>


        <div class="courses-categories-slides">
            <owl-carousel-o [options]="categoriesSlides">
                <ng-template carouselSlide *ngFor="let book of books">
                    <div class="single-categories-courses-item mb-30" style="background-image: url('{{imageUrl+book.image}}');">
                        <div class="icon">
                            <i class='bx bx-book-reader'></i>
                        </div>
                        <h3>{{book.title}}</h3>
                        <span>{{book.related_category.category_name}}</span>
                        <a routerLink="/books/{{book.id}}" class="learn-more-btn" i18n>Learn More <i class='bx bx-book-reader'></i></a>
                        <a routerLink="/books/{{book.id}}" class="link-btn"></a>
                    </div>
                </ng-template>

            </owl-carousel-o>
        </div>




    </div>
</div>